var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/util/react_router_helpers.tsx";
const _excluded = ["component", "page", "content", "componentParams", "layout", "publicRoute", "staffOnly", "adminOnly", "developerOnly"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Redirect, Route, useHistory } from 'react-router-dom';
import { Layout } from 'soapbox/components/ui';
import { useOwnAccount, useSettings } from 'soapbox/hooks';
import BundleColumnError from '../components/bundle_column_error';
import ColumnForbidden from '../components/column_forbidden';
import ColumnLoading from '../components/column_loading';
import ColumnsArea from '../components/columns_area';
import BundleContainer from '../containers/bundle_container';
const WrappedRoute = _ref => {
  let {
      component,
      page: Page,
      content,
      componentParams = {},
      layout,
      publicRoute = false,
      staffOnly = false,
      adminOnly = false,
      developerOnly = false
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const history = useHistory();
  const account = useOwnAccount();
  const settings = useSettings();
  const renderComponent = ({
    match
  }) => {
    if (Page) {
      return /*#__PURE__*/React.createElement(BundleContainer, {
        fetchComponent: component,
        loading: renderLoading,
        error: renderError,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 51,
          columnNumber: 9
        }
      }, Component => /*#__PURE__*/React.createElement(Page, _extends({
        params: match.params,
        layout: layout
      }, componentParams, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54,
          columnNumber: 15
        }
      }), /*#__PURE__*/React.createElement(Component, _extends({
        params: match.params
      }, componentParams, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 55,
          columnNumber: 17
        }
      }), content)));
    }
    return /*#__PURE__*/React.createElement(BundleContainer, {
      fetchComponent: component,
      loading: renderLoading,
      error: renderError,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 66,
        columnNumber: 7
      }
    }, Component => /*#__PURE__*/React.createElement(ColumnsArea, {
      layout: layout,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Component, _extends({
      params: match.params
    }, componentParams, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 15
      }
    }), content)));
  };
  const renderWithLayout = children => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout.Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 7
    }
  }, children), /*#__PURE__*/React.createElement(Layout.Aside, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 7
    }
  }));
  const renderLoading = () => renderWithLayout(/*#__PURE__*/React.createElement(ColumnLoading, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 48
    }
  }));
  const renderForbidden = () => renderWithLayout(/*#__PURE__*/React.createElement(ColumnForbidden, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 91,
      columnNumber: 50
    }
  }));
  const renderError = props => renderWithLayout(/*#__PURE__*/React.createElement(BundleColumnError, _extends({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 56
    }
  })));
  const loginRedirect = () => {
    const actualUrl = encodeURIComponent(`${history.location.pathname}${history.location.search}`);
    localStorage.setItem('soapbox:redirect_uri', actualUrl);
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/login",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 97,
        columnNumber: 12
      }
    });
  };
  const authorized = [account || publicRoute, developerOnly ? settings.get('isDeveloper') : true, staffOnly ? account && account.staff : true, adminOnly ? account && account.admin : true].every(c => c);
  if (!authorized) {
    if (!account) {
      return loginRedirect();
    } else {
      return renderForbidden();
    }
  }
  return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
    render: renderComponent,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 115,
      columnNumber: 10
    }
  }));
};
export { WrappedRoute };